  
  <!--
  <div class="datepickerelement" name="mydivdate" [(ngModel)]="model" [options]="myDatePickerOptions"
       angular-mydatepicker #dp="angular-mydatepicker" [ngClass]="{'placeholdercolor': !dp.isDateValid()}"
       (dateChanged)="onDateChanged($event)" (click)="dp.toggleCalendar()"
  >
    {{ model?.singleDate?.jsDate | date: 'yyyy-MM-dd'}} &nbsp; <i class="fa fa-calendar" aria-hidden="true"></i>
  </div>
  -->
  

  <!-- mat-form-field appearance="outline" class="mat-calendar-body-cell-content mat-focus-indicator ">

    <input class="mat-calendar-body-selected mat-calendar-body-today"
      matInput 
      disabled
      [matDatepicker]="datePickerOne"
      (change)="onDateChanged($event.value)"/>
    <mat-datepicker-toggle matSuffix [for]="datePickerOne" [disabled]="false">
    </mat-datepicker-toggle>
    <mat-datepicker #datePickerOne [disabled]="false">
    </mat-datepicker>
  
  </mat-form-field -->

  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Day of the trip </mat-panel-title>
        <mat-panel-description>
          Inform the date you wish to travel
          <mat-icon>date_range</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-form-field>
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" (focus)="picker.open()" readonly />
      </mat-form-field>
      <mat-datepicker #picker></mat-datepicker>
    </mat-expansion-panel>
  </mat-accordion>

  <!--
  <mat-form-field>
    < !-- mat-label>Enter a date range</mat-label -- >
    <mat-date-range-input [rangePicker]="rangePicker">
      <input matStartDate placeholder="Start date" />
      <input matEndDate placeholder="End date" />
    </mat-date-range-input>
    < !-- mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint -- >
    <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #rangePicker>
      <mat-date-range-picker-actions>
        <button mat-button matDateRangePickerCancel>Cancel</button>
        <button mat-raised-button matDateRangePickerApply>Apply</button>
      </mat-date-range-picker-actions>
    </mat-date-range-picker>
  </mat-form-field>
  -->

  <!--
  <input matInput 
    [matDatepicker]="picker" 
    placeholder="Custom Icon Datepicker"
    (dateChange)="onDateChanged($event)"
    >
    <mat-datepicker-toggle matSuffix [for]="picker">
      <mat-icon matDatepickerToggleIcon>settings</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  -->


